module.exports = __webpack_public_path__ + "static/Nerarium-8d6f1b51e57bc3105ad960088e03f4d2.gif";